<template>
  <div class="filter-wrapper widget-filter">
    <span
      v-for="(type,index) in types"
      class="filter-item"
      :class="{active: type.value === value}"
      @click="change(type.value)"
      :key="index"
    >{{type.name}}</span>
  </div>
</template>

<script>
/*
   * 用于对小部件类型的快速过滤，由多个按钮组成
   * */
export default {
  name: 'widget-filter',
  props: {
    value: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      types: [
        {
          name: this.$t('common.widget_type1'),
          value: 'all'
        },
        {
          name: this.$t('common.widget_type2'),
          value: 'navigation'
        },
        {
          name: this.$t('common.widget_type3'),
          value: 'chart'
        },
        {
          name: this.$t('common.widget_type4'),
          value: 'table'
        },
        {
          name: this.$t('common.widget_type5'),
          value: 'image'
        },
        {
          name: this.$t('common.widget_type6'),
          value: 'page'
        },
        {
          name: this.$t('common.widget_type7'),
          value: 'todo'
        }
      ]
    }
  },
  methods: {
    change (type) {
      this.$emit('input', type)
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/mixin.less";

.filter-wrapper {
  height: 32px;
  font-size: 12px;
  color: #999;
  .filter-item {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    text-decoration: none;
    margin-left: 52px;
    cursor: pointer;
    box-sizing: border-box;
    .text-over();
    &.active {
      font-weight: bold;
      color: #4c4c4c;
    }
    &:hover {
      color: #4c4c4c;
    }
  }
}
</style>
